/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { BulkDeleteVisitsErrorDtoModel, BulkDeleteVisitsErrorDtoModelType } from "./BulkDeleteVisitsErrorDtoModel"
import { BulkDeleteVisitsErrorDtoModelSelector } from "./BulkDeleteVisitsErrorDtoModel.base"
import { VisitIdsDtoModel, VisitIdsDtoModelType } from "./VisitIdsDtoModel"
import { VisitIdsDtoModelSelector } from "./VisitIdsDtoModel.base"
import { RootStoreType } from "./index"


/**
 * BulkDeleteVisitsResultDtoBase
 * auto generated base class for the model BulkDeleteVisitsResultDtoModel.
 */
export const BulkDeleteVisitsResultDtoModelBase = ModelBase
  .named('BulkDeleteVisitsResultDto')
  .props({
    __typename: types.optional(types.literal("BulkDeleteVisitsResultDto"), "BulkDeleteVisitsResultDto"),
    success: types.union(types.undefined, types.array(types.late((): any => VisitIdsDtoModel))),
    totalSuccess: types.union(types.undefined, types.integer),
    error: types.union(types.undefined, types.array(types.late((): any => BulkDeleteVisitsErrorDtoModel))),
    totalError: types.union(types.undefined, types.integer),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class BulkDeleteVisitsResultDtoModelSelector extends QueryBuilder {
  get totalSuccess() { return this.__attr(`totalSuccess`) }
  get totalError() { return this.__attr(`totalError`) }
  success(builder: string | VisitIdsDtoModelSelector | ((selector: VisitIdsDtoModelSelector) => VisitIdsDtoModelSelector) | undefined) { return this.__child(`success`, VisitIdsDtoModelSelector, builder) }
  error(builder: string | BulkDeleteVisitsErrorDtoModelSelector | ((selector: BulkDeleteVisitsErrorDtoModelSelector) => BulkDeleteVisitsErrorDtoModelSelector) | undefined) { return this.__child(`error`, BulkDeleteVisitsErrorDtoModelSelector, builder) }
}
export function selectFromBulkDeleteVisitsResultDto() {
  return new BulkDeleteVisitsResultDtoModelSelector()
}

export const bulkDeleteVisitsResultDtoModelPrimitives = selectFromBulkDeleteVisitsResultDto().totalSuccess.totalError
